// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb-module__breadcrumb___2qB6m","link":"Breadcrumb-module__link___2iqqz","active":"Breadcrumb-module__active___3bUDl"};